module.exports = __webpack_public_path__ + "static/media/claims-empty-icon.4974c9b7.svg";